<template>
    <section class="c-terms-hero">
        <y-container>
            <div class="c-terms-hero__text-wrapper">
                <h1
                    class="c-terms-hero__title"
                    v-html="textReplacer(title, 'hero-title-primary')"
                />
                <p class="c-terms-hero__synopsis">
                    {{ synopsis }}
                </p>
            </div>
        </y-container>
    </section>
</template>

<script>
// Helper
    import { textReplacer } from '@/helpers/helpers';

    export default {
        name: 'Hero',

        props: {
            title   : String,
            synopsis: String,
        },

        methods: {
            textReplacer,
        },
    };
</script>

<style lang="scss" src="./hero.scss" />
